<template>
    <SparkListItem
        :start-item="showIcons && item.icon?.icon ? 'icon' : null"
        :start-icon="item.icon?.icon ? `ph:${item.icon.icon}` : null"
        :end-item="item.link ? 'icon' : null"
        end-icon="ph:arrow-square-out"
        :class="{ 'cursor-pointer': item.link }"
        :bottom-divider="!isLast ? 'full' : null"
        @click="onClick"
    >
        <template
            v-if="item.name"
            #title
        >
            <UIHtml
                :html="item.name"
                class="prose leading-5 text-[length:inherit] text-inherit"
                style="overflow-wrap: anywhere;"
            />
        </template>
        <template
            v-if="item.subtitle"
            #description
        >
            <div class="content-sm-ux-regular mb">
                <UIHtml
                    :html="item.subtitle"
                    class="prose leading-5 text-[length:inherit] text-inherit"
                    style="overflow-wrap: anywhere;"
                />
            </div>
        </template>
    </SparkListItem>
</template>

<script setup>
    import { useRouter } from 'vue-router'
    import UIHtml from '@/components/ui/UIHtml.vue'
    import SparkListItem from '@/components/ui/SparkListItem.vue'

    const props = defineProps({
        item: Object,
        showIcons: Boolean,
        isLast: Boolean,
    })

    const router = useRouter()
    const moduleHelpers = useModuleHelpers()
    const clicking = ref(false)

    const onClick = () => {
        if (clicking.value) {
            return
        }
        clicking.value = true
        moduleHelpers.openModuleOrOpenBrowserForLinkData(router, props.item.link)
            .catch((e) => {
                console.log('Failed to open link', e)
            })
            .finally(() => {
                clicking.value = false
            })
    }
</script>
